function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import data_strategy_service from '@/services/data_strategy_service';
import utils from '@/js/utils';
import tasks from '@/js/tasks';
import { textsDefaul, envConfig, ACCESS_TYPE_FLOW, ENVIRONMENT_FLOW } from '@/js/constants';
var NOT_REPORTS = 'There are not report to assign';
export default {
  name: 'PlanPilarList',
  components: {},
  data: function data() {
    return {
      fields: [{
        key: 'name',
        label: 'Name',
        sortable: true
      }, {
        key: 'definition',
        label: 'Definition'
      }, {
        key: 'okrs.length',
        label: 'OKRs'
      }, {
        key: 'kpis.length',
        label: 'KPIs'
      }, {
        key: 'plan_data',
        label: 'Plan Data'
      }, {
        key: 'creation_date',
        label: 'Creation Date',
        class: 'text-center'
      }, {
        key: 'creation_user',
        label: 'Creation User',
        class: 'text-center'
      }, {
        key: 'action',
        label: '',
        class: 'w-15 text-center'
      }],
      items: [],
      // Representa la colección de objetos
      data_list: [],
      new_item: {},
      // representa los datos generales
      messageEmptyList: textsDefaul.LOADING,
      path_name: '',
      limit: envConfig.pagintaionSize,
      page: 1,
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      pagination: {
        total: 0,
        limit: 10,
        offset: 0,
        current: 1
      },
      isValidateLink: false,
      show_editor: false,
      readonly: false,
      nodes: {
        node1: {
          name: "Node 1"
        },
        node2: {
          name: "Node 2"
        },
        node3: {
          name: "Node 3"
        },
        node4: {
          name: "Node 4"
        }
      },
      edges: {
        edge1: {
          source: "node1",
          target: "node2"
        },
        edge2: {
          source: "node2",
          target: "node3"
        },
        edge3: {
          source: "node3",
          target: "node4"
        }
      },
      new_okr: "",
      new_kpi: "",
      key_okrs: 0,
      key_kpis: 0,
      plan_datas: []
    };
  },
  computed: {
    isEmptyTable: function isEmptyTable() {
      return !this.items.length;
    },
    composeName: function composeName() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var text = '';
        if (item) {
          text = "".concat(item.path_name, "/").concat(item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
        }
        return text;
      };
    },
    getNamePlanData: function getNamePlanData() {
      var _this = this;
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var find = _this.plan_datas.find(function (x) {
          return x.value == item.plan_data_id;
        });
        if (find) return find.text;
        return "";
      };
    }
  },
  created: function created() {
    this.reloadList();
    this.loadDataPlanes();
  },
  methods: {
    loadDataPlanes: function loadDataPlanes() {
      var _this2 = this;
      var params = {
        pagination: {
          limit: 100,
          offset: 0
        }
      };
      data_strategy_service.getPlanDataAll(params).then(function (res) {
        res.data.forEach(function (element) {
          _this2.plan_datas.push({
            value: element.id,
            text: element.description + " - " + element.year
          });
        });
      });
    },
    processParams: function processParams(params) {
      var filters = [{
        key: 'environment',
        operator: 'in',
        value: [ENVIRONMENT_FLOW.DEV, ENVIRONMENT_FLOW.TEST]
      }];
      if (params && params.clauses) {
        var clauses = params.clauses;
        if (clauses.query_type !== 'advanced') {
          for (var _i = 0, _Object$keys = Object.keys(clauses); _i < _Object$keys.length; _i++) {
            var key = _Object$keys[_i];
            if (clauses[key] && clauses[key].trim()) {
              filters.push({
                key: key,
                operator: '==',
                value: clauses[key].trim()
              });
            }
          }
        }
      }
      return _objectSpread({
        domain: window.userInfo.domain,
        pagination: {
          limit: this.pagination.limit,
          offset: this.pagination.offset
        },
        filters: filters
      }, params);
    },
    reloadList: function reloadList(params) {
      var _this3 = this;
      this.items = [];
      var defaultParams = this.processParams(params);
      this.messageEmptyList = textsDefaul.LOADING;
      data_strategy_service.getPlanPilarAll(defaultParams).then(function (res) {
        if (res && res.code === 200) {
          _this3.items = res.data;
          _this3.data_list = Object.assign([], res.data);
          _this3.pagination.total = res.data.length;
          _this3.currentPage = 1;
          _this3.messageEmptyList = res.data.length === 0 ? NOT_REPORTS : null;
        } else if (res && res.code === 400) {
          console.info(res);
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    validateKey: function validateKey(key, model) {
      if (!(key in model)) return false;
      if (model[key].toString().trim() == 0) return false;
      return true;
    },
    validateNew: function validateNew() {
      console.log(this.new_item);
      if (!this.validateKey('name', this.new_item)) {
        this.$toast.warning("Enter the name!");
        return false;
      }
      if (!this.validateKey('definition', this.new_item)) {
        this.$toast.warning("Enter the definition!");
        return false;
      }
      if (!this.validateKey('okrs', this.new_item)) {
        this.$toast.warning("Enter at least an OKR!");
        return false;
      }
      if (!this.validateKey('kpis', this.new_item)) {
        this.$toast.warning("Enter at lest a KPI!");
        return false;
      }
      if (!this.validateKey('plan_data_id', this.new_item)) {
        this.$toast.warning("Select the Strategic Data Plan!");
        return false;
      }
      return true;
    },
    onSavePlanPilar: function onSavePlanPilar() {
      var _this4 = this;
      if (!this.validateNew()) return;
      var data = {
        values: this.new_item
      };
      if (this.new_item.id) {
        data_strategy_service.updatePlanPilar(data).then(function (res) {
          console.log(res);
          if (res.success) {
            _this4.$bvModal.hide('my-modal-plan-data');
            _this4.$toast.success("Successful request!");
            _this4.reloadList();
          } else {
            _this4.$toast.warning(res.message);
          }
        });
      } else {
        data_strategy_service.createPlanPilar(data).then(function (res) {
          console.log(res);
          if (res.success) {
            _this4.$bvModal.hide('my-modal-plan-data');
            _this4.$toast.success("Successful request!");
            _this4.reloadList();
          } else {
            _this4.$toast.warning(res.message);
          }
        });
      }
    },
    onDelete: function onDelete(item) {
      var _this5 = this;
      console.log(item);
      var data = {
        "plan_pilar_id": item.id
      };
      data_strategy_service.deletePlanPilarById(data).then(function (res) {
        console.log(res);
        if (res.success) {
          _this5.$bvModal.hide('my-modal-plan-data');
          _this5.$toast.success("Successful request!");
          _this5.reloadList();
        } else {
          _this5.$toast.warning(res.message);
        }
      });
    },
    onCloseModal: function onCloseModal() {
      this.$bvModal.hide('my-modal-plan-data');
      this.new_item = {};
    },
    onCancel: function onCancel() {
      this.onCloseModal();
    },
    onPage: function onPage(page) {
      this.page = page;
      this.reloadList({
        page: page
      });
    },
    changePagina: function changePagina(pagina) {},
    onOpenNew: function onOpenNew() {
      this.readonly = false;
      this.new_item = {};
      this.isValidateLink = true;
      this.$refs['my-modal-plan-data'].show();
    },
    onEdit: function onEdit(item) {
      this.readonly = false;
      this.new_item = Object.assign({}, item);
      this.$refs['my-modal-plan-data'].show();
    },
    onAddOkr: function onAddOkr() {
      var _this6 = this;
      this.$nextTick().then(function () {
        if (_this6.new_okr.trim().length == 0) {
          _this6.$toast.warning("Enter a OKR to add!");
          return;
        }
        if ('okrs' in _this6.new_item) {
          _this6.new_item.okrs.push(_this6.new_okr);
        } else {
          _this6.new_item.okrs = [_this6.new_okr];
        }
        _this6.key_okrs += 1;
        _this6.new_okr = "";
        //this.$refs['okrs-list'].$forceUpdate()
      });
    },
    onDelOkr: function onDelOkr(index) {
      this.new_item.okrs.splice(index, 1);
      this.key_okrs += 1;
    },
    onAddKpi: function onAddKpi() {
      var _this7 = this;
      this.$nextTick().then(function () {
        if (_this7.new_kpi.trim().length == 0) {
          _this7.$toast.warning("Enter a KPI to add!");
          return;
        }
        if ('kpis' in _this7.new_item) {
          _this7.new_item.kpis.push(_this7.new_kpi);
        } else {
          _this7.new_item.kpis = [_this7.new_kpi];
        }
        _this7.key_kpis += 1;
        _this7.new_kpi = "";
        //this.$refs['okrs-list'].$forceUpdate()
      });
    },
    onDelKpi: function onDelKpi(index) {
      this.new_item.kpis.splice(index, 1);
      this.key_kpis += 1;
    },
    onView: function onView(item) {
      this.new_item = Object.assign({}, item);
      this.readonly = true;
      this.$refs['my-modal-plan-data'].show();
    }
  }
};